module.exports = __webpack_public_path__ + "img/SideDish.a23c8127.jpg";